import { watch, onMounted, computed } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';

// #26 — mostra a quantidade de não-lidas no título da aba do navegador
// ("(15) ByChat"), estilo WhatsApp Web. Útil pra quem usa o app encapsulado.
// Aditivo: um watcher sem tocar no layout/roteador.
//
// Fonte da contagem: `conversationUnreadCounts/getAllUnreadCount` só é preenchido
// quando a feature interna `conversation_unread_counts` está ligada (off por
// padrão). Então usamos como base a contagem de notificações
// (`notifications/getUnreadCount`) — sempre disponível e já usada no badge do menu
// "Caixa de Entrada" — e deixamos a de conversas sobrepor quando existir.
export function useUnreadDocumentTitle() {
  const convUnread = useMapGetter('conversationUnreadCounts/getAllUnreadCount');
  const notifUnread = useMapGetter('notifications/getUnreadCount');
  const count = computed(
    () => Number(convUnread.value) || Number(notifUnread.value) || 0
  );
  let base = '';

  const apply = () => {
    const n = count.value;
    document.title = n > 0 ? `(${n}) ${base}` : base;
  };

  onMounted(() => {
    // título base = o que veio no <head> (INSTALLATION_NAME), sem prefixo antigo
    base = (document.title || '').replace(/^\(\d+\)\s*/, '');
    apply();
  });

  watch(count, apply);
}
